// extracted by mini-css-extract-plugin
module.exports = {"wrap":"video-lesson_wrap__Gns3G","title":"video-lesson_title__esqTh","text":"video-lesson_text__Ec62t"};